import { useTranslation } from "react-i18next";
import Legend from "../components/Legend";

type SectionSpec = {
  key: string;
  list?: "ol" | "ul";
};

// Order of the manual. `list` controls how the section's items render:
// "ol" for sequential steps, "ul" for unordered points.
const SECTIONS: SectionSpec[] = [
  { key: "overview" },
  { key: "goal" },
  { key: "components", list: "ul" },
  { key: "readingCodes", list: "ul" },
  { key: "turn" },
  { key: "composeA", list: "ol" },
  { key: "composeB", list: "ol" },
  { key: "interpret", list: "ol" },
  { key: "scoringCoded", list: "ul" },
  { key: "scoringInvented", list: "ul" },
  { key: "ending", list: "ul" },
];

export default function HowTo() {
  const { t, i18n } = useTranslation();

  const arr = (key: string): string[] => {
    if (!i18n.exists(key)) return [];
    const v = t(key, { returnObjects: true }) as unknown;
    return Array.isArray(v) ? (v as string[]) : [];
  };

  return (
    <div className="howto">
      <header className="howto__head">
        <h1>{t("howto.title")}</h1>
        <p className="howto__tagline">{t("howto.tagline")}</p>
        <p className="howto__note">{t("howto.playtestNote")}</p>
        <p className="howto__note howto__note--muted">{t("howto.simulatorNote")}</p>
      </header>

      <div className="howto__grid">
        {SECTIONS.map(({ key, list }) => {
          const body = arr(`howto.${key}.body`);
          const items = arr(`howto.${key}.items`);
          return (
            <section key={key} className="card howto__section">
              <h2>{t(`howto.${key}.heading`)}</h2>
              {body.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              {items.length > 0 &&
                (list === "ol" ? (
                  <ol>
                    {items.map((it, i) => (
                      <li key={i}>{it}</li>
                    ))}
                  </ol>
                ) : (
                  <ul>
                    {items.map((it, i) => (
                      <li key={i}>{it}</li>
                    ))}
                  </ul>
                ))}
            </section>
          );
        })}
      </div>

      <h2 className="howto__legend-heading">{t("howto.legendHeading")}</h2>
      <Legend />

      <p className="howto__closing">{t("howto.closing")}</p>
    </div>
  );
}
